import React, { useState, useEffect, useRef } from "react";

function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isChecking, setIsChecking] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setIsChecking(false);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setIsChecking(false);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleRetry = () => {
    setIsChecking(true);

    timeoutRef.current = setTimeout(() => {
      if (!navigator.onLine) {
        setIsChecking(false);
      }
    }, 10000);

    if (navigator.onLine) {
      setIsOnline(true);
      setIsChecking(false);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    } else {
      window.location.reload();
    }
  };

  if (isOnline) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-red-600 text-white px-4 py-3 flex flex-col items-center gap-2 shadow-lg">
      <p className="text-sm font-medium text-center">
        इंटरनेट कनेक्शन उपलब्ध नहीं है। कृपया जांच करें।
      </p>
      <button
        onClick={handleRetry}
        disabled={isChecking}
        className={`flex items-center gap-2 px-4 py-1.5 rounded-md text-sm font-semibold transition ${
          isChecking
            ? "bg-red-400 cursor-not-allowed"
            : "bg-white text-red-600 hover:bg-gray-100"
        }`}
      >
        {isChecking ? (
          <span className="w-4 h-4 border-2 border-red-600 border-t-transparent rounded-full animate-spin" />
        ) : (
          "🔃"
        )}
        {isChecking ? "कोशिश की जा रही है..." : "फिर से कोशिश करें"}
      </button>
    </div>
  );
}

export default NetworkStatus;